import React, { FC } from 'react'
import styles from './style.module.scss'
import Link from 'next/link'

export type Breadcrumb = {
  name: string
  href?: string
}

export type BreadcrumbsProps = {
  items: Breadcrumb[]
}

export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
  const BreadItems = props.items.map((item, idx) => {
    return (
      <div className={styles.breadcrumbsItem} key={idx}>
        <div className={styles.breadcrumbsItemLink}>
          {item.href ? (
            <Link href={item.href} passHref>
              <a className={styles.breadcrumbsItemLinkValue}>
                {item.name}
              </a>
            </Link>
          ) : (
            item.name
          )}
        </div>
        {props.items.length - 1 !== idx && (
          <span className={styles.breadcrumbsItemIcon}>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
              <path d="M1 1L5 5L1 9" stroke="#222327" />
            </svg>
          </span>
        )}
      </div>
    )
  })
  return <div className={styles.breadcrumbs}>{BreadItems}</div>
}
